import { FunctionsFetchError, FunctionsHttpError, FunctionsRelayError } from "@supabase/supabase-js"

/**
 * Extracts error message from Supabase function errors
 * @param error - The error from supabase.functions.invoke
 * @returns Human-readable error message
 */
export async function getSupabaseFunctionErrorMessage(error: unknown): Promise<string> {
  if (error instanceof FunctionsHttpError) {
    try {
      const errorData = await error.context.json()
      return errorData.message || errorData.error || error.message
    } catch {
      return error.message
    }
  } else if (error instanceof FunctionsRelayError) {
    return error.message
  } else if (error instanceof FunctionsFetchError) {
    return error.message
  } else if (error instanceof Error) {
    return error.message
  }
  return "Unknown error"
}
